import { Box, Flex, Spinner, useColorMode } from '@chakra-ui/react'
import { Moment } from 'config'
import { useReport } from 'hooks'
import Apex from 'react-apexcharts'

export default function ClientsDailyGrowthChart({ period, ...props }){

    const { colorMode } = useColorMode()
    const report = useReport('clients_daily_growth', period)

    const dates = report.data?.data?.map(item => item.date)
    const values = report.data?.data?.map(item => item.daily_growth)

    const series = [
        {
            name: 'Novos consultores',
            data: values
        }
    ]

    const options = {
        theme: { 
            mode: colorMode,
            palette: 'palette10'
        },
        title: {
            text: "Crescimento de clientes por período",
            align: 'center'
        },
        subtitle: {
            text: `Com dados de ${Moment(report.data?.metadata?.starts).format('LL')} até ${Moment(report.data?.metadata?.ends).format('LL')} | Última atualização ${Moment(report.data?.metadata?.updated_at).calendar()}`,
            align: 'center'
        },
        chart: { 
            height: 350, 
            type: 'area', 
            background: 'transparent',
            locales: [require('apexcharts/dist/locales/pt.json')],
            defaultLocale: 'pt',
            foreColor: 'orange',
            zoom: { 
                enabled: true 
            }, 
            animations: { 
                enabled: true, 
                easing: 'easeinout', 
                animateGradually: {
                    enabled: true,
                    delay: 150 
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            } 
        },
        dataLabels: { 
            enabled: false 
        },
        stroke: { 
            curve: 'smooth'
        },
        grid: { 
            show: false 
        },
        xaxis: { 
            type: 'datetime', 
            categories: dates 
        },
        tooltip: { 
            x: { 
                format: 'dd/MM/yy' 
            }, 
        }
    }

    // Loading state
    if(report.isLoading) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    // Chart
    return <Apex options={options} series={series} type="area" height={350} />
}